// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3egNi","calendarButtons":"ClockData_calendarButtons__2cAQM"};